export default function Accordion(props) {
  return (
    <div className="w-full border-b">
      <button
        className="w-full p-4 text-lg text-left transition duration-300 h-14"
        onClick={props.toggleAccordion}
      >
        {props.title}
        <span
          className={`float-right transform ${
            props.isOpen ? "rotate-180" : "rotate-0"
          }  
                                 transition-transform duration-300`}
        >
          &#9660;
        </span>
      </button>
      {props.isOpen && <div className="p-4 bg-gray-100">{props.data}</div>}
    </div>
  );
}
